import { Helmet } from 'react-helmet-async';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import UiStackTemplate from '@/components/layouts/UiStackTemplate';
import PageTitle from '@/components/ui/headers/PageTitle';
import { pageTitles } from '@/constants/pageTitles';
import ShinroMainButtonArea from '@/features/shinro/components/ShinroMainButtonArea';
import ShinroSection from '@/features/shinro/components/ShinroSection';

import { ShinroRelease } from '../constants/shinroRelease';

import { articleThemes } from './shinroArticles';
import CSSModule from './ShinroIndexPage.module.scss';

const currentRelease = (release: string) => ShinroRelease?.current === release;

const ShinroIndexPage: React.FC = () => (
  <>
    <Helmet>
      <title>{pageTitles.shinroInformations}</title>
    </Helmet>
    <SingleColumnTemplate>
      <div className={CSSModule.wrapper}>
        <PageTitle title={pageTitles.shinroInformations} />
        <UiStackTemplate isLoading={false} isError={false}>
          <div className={CSSModule.inner}>
            <ShinroMainButtonArea />
            <hr />
            <div className={CSSModule.ShinroSectionArticleHeader}>
              <h1 className={CSSModule.ShinroSectionArticleHeader__Title}>
                保護者向け 受験・進路コラム
              </h1>
              <p className={CSSModule.ShinroSectionArticleHeader__Description}>
                受験・進路の基本的な理解やお悩みや疑問の解消に役立つコラムを【期間限定】でお届けします
              </p>
            </div>
            {articleThemes.map((theme) => (
              <ShinroSection
                key={theme.title}
                title={theme.title}
                articles={theme.articles}
                currentRelease={currentRelease(theme.release)}
              />
            ))}
          </div>
        </UiStackTemplate>
      </div>
    </SingleColumnTemplate>
  </>
);

export default ShinroIndexPage;
